module.exports = "assets/loading-0.gif?a72011";


//////////////////
// WEBPACK FOOTER
// ../node_modules/layui-layer/loading-0.gif
// module id = 16
// module chunks = 1